const TOKEN_KEY = 'token';
const USER_INFO_KEY = 'userInfo';

const isLogin = () => {
  return !!localStorage.getItem(TOKEN_KEY);
};

const getToken = () => {
  return localStorage.getItem(TOKEN_KEY);
};

const setToken = (token: string) => {
  localStorage.setItem(TOKEN_KEY, token);
};

const clearToken = () => {
  localStorage.removeItem(TOKEN_KEY);
};

// 清除所有认证相关的数据
const clearAllAuthData = () => {
  // 清除token
  clearToken();

  // 清除用户信息
  localStorage.removeItem(USER_INFO_KEY);

  // 清除主题设置
  localStorage.removeItem('arco-theme');

  // 清除sessionStorage
  sessionStorage.clear();

  // 清除可能的cookie
  document.cookie.split(';').forEach((c) => {
    document.cookie = c
      .replace(/^ +/, '')
      .replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`);
  });
};

// 检查token是否过期
const isTokenExpired = (): boolean => {
  const token = getToken();
  if (!token) {
    return true;
  }

  try {
    // 解析JWT token（如果使用JWT）
    const payload = JSON.parse(atob(token.split('.')[1]));
    const currentTime = Date.now() / 1000;

    // 检查是否过期（提前5分钟认为过期）
    return payload.exp < currentTime + 300;
  } catch (error) {
    // 如果解析失败，认为token无效
    return true;
  }
};

// 获取token剩余有效时间（秒）
const getTokenExpiryTime = (): number => {
  const token = getToken();
  if (!token) {
    return 0;
  }

  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const currentTime = Date.now() / 1000;
    return Math.max(0, payload.exp - currentTime);
  } catch (error) {
    return 0;
  }
};

export {
  isLogin,
  getToken,
  setToken,
  clearToken,
  clearAllAuthData,
  isTokenExpired,
  getTokenExpiryTime,
};
